import { FlagIcon } from "app/components/Icons";
import CommonPrioritySelection from "app/containers/Features/components/CommonPrioritySelection";
import { getPriorityByIds } from "app/containers/Features/containers/Boards/helpers";
import React, { useMemo } from "react";
import { PriorityFilterEnum } from "app/types";
import StatusSelectionButton from "./StatusSelectionButton";
import clsx from "clsx";
import { dropdownTriggerClassname } from "app/components/Dropdown";

interface PriorityDropdownProps {
  value: PriorityFilterEnum;
  setValue: (value: PriorityFilterEnum) => void;
}

const PriorityDropdown: React.FC<PriorityDropdownProps> = ({
  setValue,
  value,
}) => {
  const selectedPriority = useMemo(() => {
    return getPriorityByIds(value);
  }, [value]);
  const handleSelect = (value) => {
    setValue(value);
  };

  return (
    <CommonPrioritySelection
      trigger={
        <button
          className={clsx(
            "flex items-center justify-between w-full px-2 py-2 rounded-md ",
            dropdownTriggerClassname,
          )}
        >
          <StatusSelectionButton
            label="Priority:"
            selectedIcon={selectedPriority?.icon}
            selectedLabel={selectedPriority?.label ?? "-"}
            icon={<FlagIcon size={20} color="#79808A" />}
            className="text-[12px] leading-[18px] font-medium text-secondary mt-[2px]"
          />
        </button>
      }
      align="end"
      value={value}
      setValue={handleSelect}
      dropDownClassName="min-w-[210px]"
    />
  );
};

export default PriorityDropdown;
